module.exports = __webpack_public_path__ + "img/pic_5.174e7aba.png";